import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

interface MenuItem {
  label: string;
  route: string;
  external?: boolean;
}

@Component({
  selector: 'app-header-redesign',
  templateUrl: './header-redesign.component.html',
  styleUrls: ['./header-redesign.component.scss']
})
export class HeaderRedesignComponent {

  menuItems: MenuItem[] = [
    {
      label: 'Home',
      route: '/home-redesign'
    },
    {
      label: 'About us',
      route: '/about-redesign'
    },
    {
      label: 'Platform',
      route: '/platform-redesign'
    },
    {
      label: 'Solutions',
      route: '/solutions-redesign'
    },
    {
      label: 'News',
      route: '/news-redesign'
    }
  ];

  isMenuOpen = false;
  isHome = false;

  constructor(private router: Router) {

    // Estado inicial
    this.updateHeaderStyle(this.router.url);

    // Escucha los cambios de ruta
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {

        this.updateHeaderStyle(event.urlAfterRedirects);
        this.isMenuOpen = false;

      });

  }

  private updateHeaderStyle(url: string): void {

    this.isHome = true; //url === '/home-redesign';

  }

  toggleMenu(): void {

    this.isMenuOpen = !this.isMenuOpen;

  }

}